import * as React from "react";
import { observer } from "mobx-react";
import { hashHistory } from "react-router";
import { observable } from "mobx";
import SeekerStore from "../../../stores/seekerStore";
import { OpportunitySummary } from "../../../models/opportunity";
import { ILocalization } from "../../../models/localization";
import { sort } from "../../../utils/data";
import List, { ListItem, ListItemText } from "material-ui/List";
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card';
import { Row, Col, Grid } from "react-flexbox-grid";
import IconButton from "material-ui/IconButton";
import ArrowButton from "material-ui-icons/ArrowBack";
import ExpandMoreIcon from "material-ui-icons/ExpandMore";
import Button from "material-ui/Button";
import { Opportunity } from "../../../models/opportunity";
import { FeaturedLabel, ApplyNowLabel } from "../../widgets/opLabels";
import ExpansionPanel, { ExpansionPanelDetails, ExpansionPanelSummary, ExpansionPanelActions } from "material-ui/ExpansionPanel";
import * as s from "./opSummary.css";

@observer
export default class OpportunitySummaryCard extends React.Component<{ store: SeekerStore, op: OpportunitySummary }, {}> {
  @observable opp: Opportunity;
  constructor(props: any) {
    super(props);
    this.opp = this.props.store.opportunityStore.getOpportunity(this.props.op.idHash);
  }
  render(): JSX.Element {
    if (!this.props.op) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    const os: OpportunitySummary = this.props.op;
    let requirements:string = "";
    let topSkills:string = "";
    const imgUrl: string = "../image/" + os.imageId;

    for (let entry of os.prereqs) {
      requirements += entry + "\n";
    }
    for (let skill of os.topSkills) {
      topSkills += skill + "\n";
    }
    const styles = {
      MuiIconButton: {
        color: "#5B6770",
      },
      expansionPanel: {
        boxShadow: "none",
        background: "transparent",
      },
      expansionSummary: {
        paddingLeft: "16px",
      },
      expansionDetails: {
        display: "block",
      }
    };

    return (<Col xs={12} sm={6} md={4} lg={3} xl={3} key={"ops-" + os.idHash} >
      <div>
        <div className={s.outerBox}>
          <img onClick={() => hashHistory.push(`opportunities/${os.idHash}`)} src={imgUrl} className={s.clickable} />
          <div className={s.innerBox}></div>
          <div className={s.onTop} onClick={() => hashHistory.push(`opportunities/${os.idHash}`)}>
            <p className={s.locationText}>{os.location}</p>
            <p className={s.locationText}>{os.postedBy}</p>
          </div>
          <FeaturedLabel store={this.props.store} op={this.opp} isNew={os.flagAsNew} allowApply={os.allowApply}  />       
        </div>
        <div>
          <ExpansionPanel style={styles.expansionPanel}>
            <ExpansionPanelSummary style={styles.expansionSummary} expandIcon={<ExpandMoreIcon color="secondary" />} >
              <p className={s.summaryHeading}>{os.name}</p>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={styles.expansionDetails}>
              <p className={s.subheading}>{local.topSkills}</p>
              <ul className={s.prereqs}>{topSkills.split("\n", os.topSkills.length).map((i, n: number) => { return (<li key={"prereq-" + n}>{i}</li>) })}</ul>
              <p className={s.subheading}>{local.prereqLabel}</p>
              <ul className={s.prereqs}>{requirements.split("\n", os.prereqs.length).map((i, n: number) => { return (<li key={"required-" + n}>{i}</li>) })}</ul>
              <br />
              <Button onClick={() => hashHistory.push(`/opportunities/${os.idHash}`)} raised color="secondary" aria-label="add">{local.viewMore}</Button>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      </div>
    </Col>);
  }
}



// WEBPACK FOOTER //
// ./src/components/opportunity/opSummary/index.tsx